import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { UserService } from '../services/user.service';
import { CommunicationService } from '../services/communication.service';
import { ListingsService } from '../services/listings.service';

@Injectable()
export class PropTypeResolver implements Resolve<any> {

  constructor(private _listingsService: ListingsService) { }

  resolve(route: ActivatedRouteSnapshot, rstate: RouterStateSnapshot): Observable<any> {
    const province = route.url[0].path;
    // TODO: Variables
    // land, houses, condos, farms, townhouses, recreational
    const propRegex =  /(\S+)-(land|farms|houses|townhouses|condos|farms|recreational)-for-sale/;
    let pageNumber = Number(route.queryParams.page) || 0; // For Pagination
    // We need to remember to decrement this value as pagination arrays start from 0
    if (pageNumber > 0) pageNumber--;

    const propMatches = propRegex.exec(route.url[1].path);
    // If the URL they give doesnt match the default format return null
    if (propMatches && propMatches.length === 3) {
      const city = propMatches[1];
      const propType = propMatches[2];
      const propTypeSingular = propType[propType.length - 1] === 's' ? propType.slice(0, propType.length - 1) : propType;

      // Make a call to the listings to find the total hits before returning
      return this._listingsService.getListingsCount(false, province, city, propTypeSingular, false).pipe(
        map((hits) => {
          return {propType: propType, city: city, province: route.url[0].path, totalListings: hits, pageNumber: pageNumber, isOpenHouse: false};
        }),
        // FIXME: What should i do here
        catchError((err) => {
          return of({propType: propType, city: city, province: route.url[0].path, totalListings: 0, pageNumber: pageNumber, isOpenHouse: false});
        }));
    }
    else return of(null);
  }
}
